import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { IoChevronDownSharp } from 'react-icons/io5';
import { Fragment } from 'react';
import DefaultButton from '@/components/common/default/DefaultButton';
import DefaultLink from '@/components/common/default/DefaultLink';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexV2Enum } from '@/types/translations/IndexV2Enum';
import { IndexNavItemChildrenTypeEnum } from '@/types/constants/enums';
import { IndexNavItem } from '@/types/constants/types';

export default function IndexNavCommon({ label, items }: { label: string; items: IndexNavItem[] }) {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <Menu>
      <MenuButton as={Fragment}>
        <DefaultButton className="tw-text-base tw-font-medium tw-text-textBlack">
          {label} <IoChevronDownSharp className="tw-text-base tw-font-medium tw-text-textBlack" />
        </DefaultButton>
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom start"
        className="tw-[--anchor-gap:var(--spacing-1)] !tw-max-w-auto tw-top-[140px] tw-z-[99999] tw-flex !tw-max-h-[500px] tw-origin-top-right tw-flex-nowrap tw-items-start tw-gap-4 tw-overflow-y-auto tw-rounded-xl tw-border tw-border-solid tw-border-gray-300 tw-bg-white tw-p-1 tw-text-sm/6 tw-text-white tw-shadow-lg tw-transition tw-duration-100 tw-ease-out focus:tw-outline-none data-[closed]:tw-scale-95 data-[closed]:tw-opacity-0 child:tw-w-auto"
      >
        {items.map(item => (
          <MenuItem key={item.label}>
            <ul className="tw-mb-0 tw-p-0 tw-px-1 tw-py-4">
              <li className="tw-mb-2 tw-w-full">
                <strong className="tw-py-2 tw-pl-2 tw-pr-8 tw-text-base tw-font-bold tw-text-[#272D37]">
                  {translate(item.label)}
                </strong>
              </li>
              {item.children.map(child => {
                if (child.type === IndexNavItemChildrenTypeEnum.translate) {
                  return (
                    <li key={child.label} className="tw-w-full">
                      <DefaultLink
                        href={child.href}
                        className="tw-w-full tw-rounded-md tw-py-2 tw-pl-2 tw-pr-8 tw-text-left tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-[#f5f5f5] hover:tw-text-textBlack"
                      >
                        {translate(child.label)}
                      </DefaultLink>
                    </li>
                  );
                }

                return (
                  <li key={child.label} className="tw-w-full">
                    <DefaultLink
                      href={child.href}
                      className="tw-w-full tw-rounded-md tw-py-2 tw-pl-2 tw-pr-8 tw-text-left tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-[#f5f5f5] hover:tw-text-textBlack"
                    >
                      {child.label}
                    </DefaultLink>
                  </li>
                );
              })}
            </ul>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
